import {ExportOutlined, RollbackOutlined} from '@ant-design/icons';
import type {TableColumnsType} from 'antd';
import {Button, message, Modal, Select} from 'antd';
import {PaginationCustom} from 'components/element/PaginationCustom';
import {TableCustom} from 'components/element/TableCustom';
import {
  useExportBalance,
  useGetBanlance,
  useGetDetailUser,
} from 'hooks/balance';
import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {addKeyData, formatDate, formatNumberValue} from 'utils';
export const BalanceHistory: React.FC = () => {
  const params = useParams();
  const navigate = useNavigate();

  const [filters, setFilters] = useState({});
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [selectedMonths, setSelectedMonths] = useState<number>(1);

  const {
    data: getData,
    isLoading,
    isSuccess,
    isError,
  } = useGetBanlance({...filters, userID: params?.id});

  const {data: detailUser} = useGetDetailUser(params?.id ?? '');

  const exportBalanceMutation = useExportBalance();

  const monthOptions = [
    {label: '1 tháng', value: 1},
    {label: '3 tháng', value: 3},
    {label: '6 tháng', value: 6},
    {label: '9 tháng', value: 9},
    {label: '12 tháng', value: 12},
  ];

  const handleExport = async () => {
    if (!params?.id) {
      message.error('Không tìm thấy thông tin người dùng');
      return;
    }

    try {
      const blob = await exportBalanceMutation.mutateAsync({
        userID: params.id,
        months: selectedMonths,
      });

      // Tạo URL để download file
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${detailUser?.name}-${selectedMonths}-months.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      message.success('Xuất file thành công');
      setIsExportModalOpen(false);
    } catch (error) {
      message.error('Có lỗi xảy ra khi xuất file');
    }
  };

  if (isError) {
    message.error('Không tìm thấy thông tin giao dịch');
  }
  useEffect(() => {
    if (detailUser) {
      document.title = `${detailUser.name} - Lịch sử giao dịch`;
    }
  }, [detailUser]);
  const columns: TableColumnsType = [
    {
      title: 'Nội dung',
      dataIndex: 'reason',
      key: 'code',
      align: 'left',
      width: 280,
      render: data => <div className="font-medium">{data}</div>,
    },
    {
      title: 'Số dư cũ',
      dataIndex: 'balance',
      key: 'balance',
      align: 'center',
      width: 150,
      render: data => {
        return (
          <div className="whitespace-nowrap">
            <p>{formatNumberValue(data)}</p>
          </div>
        );
      },
    },
    {
      title: 'Số dư biến động',
      dataIndex: 'loadedBalance',
      key: 'loadedBalance',
      align: 'center',
      width: 160,
      render: data => {
        return (
          <div className="whitespace-nowrap font-semibold">
            <p className={Number(data) > 0 ? 'text-green-600' : 'text-red-500'}>
              {Number(data) > 0 ? `+${formatNumberValue(data)}` : formatNumberValue(data)}
            </p>
          </div>
        );
      },
    },
    {
      title: 'Số dư cuối cùng',
      dataIndex: 'newBalance',
      key: 'newBalance',
      align: 'center',
      width: 160,
      render: data => {
        return (
          <div className="whitespace-nowrap font-medium">
            <p>{formatNumberValue(data)}</p>
          </div>
        );
      },
    },
    {
      title: 'Ngày thay đổi',
      dataIndex: 'createdAt',
      key: 'createdAt',
      align: 'center',
      width: 170,
      render: data => {
        return (
          <div className="whitespace-nowrap">
            <p>{formatDate(data)}</p>
          </div>
        );
      },
    },
  ];
  return (
    <div className="container mx-auto">
      <div className="flex-col gap-4">
        <div className="flex justify-between items-center">
          <h2 className="text-2xl font-bold">
            Lịch sử giao dịch của: {detailUser?.name}
          </h2>
          <div className="flex gap-2">
            <Button
              icon={<ExportOutlined />}
              onClick={() => setIsExportModalOpen(true)}
              type="primary">
              Export Excel
            </Button>
            <Button
              icon={<RollbackOutlined />}
              onClick={() => {
                navigate(-1);
              }}>
              Trở về
            </Button>
          </div>
        </div>
        <div className=" flex flex-col items-end gap-3">
          <TableCustom
            isLoading={isLoading}
            columns={columns}
            data={addKeyData(getData?.result)}
            scroll={{x: 1000, y: 590}}
          />
          <PaginationCustom
            totalPage={getData?.totalPage ?? 1}
            current={getData?.page ?? 1}
            pageSize={getData?.pageSize ?? 10}
            onChange={(page, pageSize) => {
              console.log(page, pageSize);
              setFilters({...filters, page, pageSize});
            }}
            onShowSizeChange={(current, size) => {
              setFilters({...filters, page: current, pageSize: size});
            }}
          />
        </div>
      </div>

      <Modal
        title="Xuất lịch sử giao dịch"
        open={isExportModalOpen}
        onOk={handleExport}
        onCancel={() => setIsExportModalOpen(false)}
        confirmLoading={exportBalanceMutation.isLoading}
        okText="Xuất file"
        cancelText="Hủy">
        <div className="mb-4">
          <label className="block text-sm font-medium mb-2">
            Chọn khoảng thời gian:
          </label>
          <Select
            value={selectedMonths}
            onChange={setSelectedMonths}
            options={monthOptions}
            className="w-full"
            placeholder="Chọn thời gian"
          />
        </div>
      </Modal>
    </div>
  );
};
